import { AxiosInstance } from 'axios'
import { useEffect, useState } from 'react'

export function useApContextDataRest(aiCode?: string, diCode?: string, client?: AxiosInstance) {
  const [state, set] = useState<any>({ data: undefined, loading: false, error: undefined })

  useEffect(() => {
    if (!aiCode || !diCode) return
    if (!client) {
      set({ ...state, error: new Error('No REST client') })
      return
    }

    let cancel = false
    set((s) => ({ ...s, loading: true, error: undefined }))

    client
      .post('/apcontextdata', { ai_code: aiCode, di_code: diCode })
      .then(
        (r) =>
          !cancel &&
          set({
            data: {
              getApContextData: r.data,
            },
            loading: false,
            error: undefined,
          })
      )
      .catch((e) => !cancel && set({ data: undefined, loading: false, error: e }))

    return () => {
      cancel = true
    }
  }, [aiCode, client])

  return state
}
